import { Typography } from '@jouzen/ecom-components/v3/Typography';
import type { ReactNode } from 'react';

import {
  AffiliateMessage,
  GenericEyebrow,
  type GenericEyebrowProps,
} from '@/app/components/Eyebrow/EyebrowMessage';
import type {
  EyebrowConfig,
  EyebrowProps,
} from '@/app/components/Eyebrow/types';

import { EyebrowMessageEnum } from '../_hooks/useEyebrowConfig';

interface EyebrowMessageProps {
  displayMessage: string | null | ReactNode;
  eyebrowConfig: EyebrowConfig;
  eyebrowMessageType: EyebrowMessageEnum;
}

const eyebrowMessage = ({
  displayMessage,
  eyebrowConfig,
  eyebrowMessageType,
}: EyebrowMessageProps): EyebrowProps => {
  // display the discount message on hardware PDP if one
  if (eyebrowMessageType === EyebrowMessageEnum.PDP_HARDWARE_MESSAGE) {
    return {
      className: 'bg-black',
      displayMessage: () => (
        <Typography
          className="flex-wrap items-center justify-center gap-x-1 text-center"
          color="light"
          data-cy="discount-message-text"
          style={{ hyphens: 'none' }}
          variant="body-small"
          weight="bold"
        >
          {displayMessage}
        </Typography>
      ),
    };
  }
  // display the statsig message
  if (eyebrowMessageType === EyebrowMessageEnum.STATSIG_MESSAGE) {
    return {
      className:
        eyebrowConfig.className ?? 'bg-sandstone-200 text-sandstone-500',
      displayMessage: () => (
        <GenericEyebrow
          {...(eyebrowConfig as unknown as GenericEyebrowProps)}
        />
      ),
    };
  }
  // display the hidden affiliate message
  return {
    displayMessage: AffiliateMessage,
    className: 'hidden',
    id: 'partner_eyebrow',
  };
};

export default eyebrowMessage;
